import React, { useEffect, useState } from 'react';
import {IProps, IState} from './types';
import * as S from './styles';

const Avatar: React.FC<IProps> = (props) => {

  const getText = (text: string) => {
    let letter = "A";
    if (text.length) letter = text.charAt(0).toUpperCase(); 
    return letter;
  }

  return (
    <S.Root style={props.styles}>
      <S.Text style={props.textStyles}>
        {getText(props.text)}
      </S.Text>
    </S.Root>
  );
}

export default Avatar;